module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-three-smc/key-3-2015.svg?v=55b0ba38";